<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullpath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullpath"></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',

  components: {
    
  },
  data: () => ({
    account: "",
    isLogin: false,
    drawer: true,
    sheet: false
  }),
  created: function() {
    //this.account = this.connectPortal()
  },
  updated() {
    window.scroll(0, 0);
  },
  methods: {
    showMore: function() {
      this.sheet = true;
    }
  }

};
</script>

<style scoped>
  .tuoyuan {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #7CD77B;
  }

  .main-body {
    background-color: #F4F4F4;
  }

  .head-btn {
    margin: 0px 16px;
    min-width: 100pt!important;
    height: 28px!important;
  }

  .head-img {
    margin: 0px 16px;
  }

  .card-box {
    padding-left: 16px;
  }

  .card-name {
    height: 32pt;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.016) 0%, rgba(0, 0, 0, 0.6) 75.43%, rgba(0, 0, 0, 0.72) 100%);
    backdrop-filter: blur(10px);
    display: block;
    position: absolute;
    bottom: 0px;
    color: white;
    line-height: 25pt;
    width: 100%;
    font-size: 9pt;
    padding-left:10px;
  }

  .card-auction {
      height: 37pt;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.016) 0%, rgba(0, 0, 0, 0.6) 75.43%, rgba(0, 0, 0, 0.72) 100%);
      backdrop-filter: blur(10px);
      display: block;
      position: absolute;
      bottom: 0px;
      color: white;
      line-height: 32pt;
      width: 100%;
      font-size: 9pt;
      padding-left:10px;
  }

  .nft-subname {
    height: 12pt;
    line-height: 16pt;
    width: 100%;
    display: block;
  }

  .nft-price {
    height: 12pt;
    line-height: 16pt;
    width: 100%;
    display: block;
    color: #3DDCFF;

  }

  .auction-clock {
    height: 12pt;
    width: 12pt;
  }

  .auction-times {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 12pt;
    line-height: 12pt;
    font-family: Fira Sans;
    font-style: normal;
    font-size: 9pt;
    text-transform: uppercase;
  }

  .news-mark {
    font-family: Fira Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #222222;
    opacity: 0.7;
  }
</style>
